import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import apiConfig from "./../../../config/api";
import {
  MenuItem, SelectField, RaisedButton, Card, CardText, CardHeader, TextField, Drawer, Dialog,
  DatePicker, FlatButton, CircularProgress
} from "material-ui";
import DateIcon from "material-ui/svg-icons/action/date-range";
import customDateTimeFormat from "../../../helpers/dateFormat";
import banmedicaTheme from "./../../../config/banmedicaTheme";
import {
  Loading, InfoExpand, BuscarArancelesDetalle, ValidarPeriodoReajuste, ValidarPeriodoReajustePaquetes,
  CambiarFechaVigenciaConsultaPeriodo, SetSolicitudesEnCurso, LoadingFileArancelCompleto
} from "./actions";
import ErrorSnack from "../../ErrorSnack/view";
import {
  ObtenerCentrosAtencion, ObtenerTiposArancel, ObtenerTiposPrestacion,
  CambiarTipoArancel, CambiarCentroAtencion, ObtenerUsuariosPerfil, CambiarTipoPrestacion,
  CambiarCodFonasa, CambiarCodPrestacion, ObtenerDatosUsuario,
} from "../../Global/actions";
import ConsultaArancelDetalle from "../ConsultaArancelDetalle/view";
import SolicitudReajuste from "../SolicitudReajuste/view";
import SolicitudReajusteConfirmacion from "../SolicitudReajusteConfirmacion/view";
import SolicitudReajusteRespuesta from "../SolicitudReajusteRespuesta/view";
// import PeriodoNoValido from "../PeriodoNoValido/view";

import styles from "../../styles/styles";
import {
  ModalConsultarPeriodoReajuste, ModalSolicitudReajustePaso, DownloadArancelCompleto,
  DownloadArancelSeleccionado, GetSolicitudesExcel
} from "../SolicitudReajuste/actions";
import DialogAlert from "../../../componentsGlobal/DialogAlert";

const moment = require("moment");


class FiltroBusquedaRA extends React.Component {
  state = { pagina: 1, infoAlert: false }

  componentWillMount() {
    const dateMin = new Date(Date.now());
    this.props.dispatch(ValidarPeriodoReajuste(dateMin));
    this.props.dispatch(ValidarPeriodoReajustePaquetes(dateMin));
    this.props.dispatch(ObtenerCentrosAtencion());
    this.props.dispatch(ObtenerUsuariosPerfil(`${apiConfig.usuariosConvenios}`, 2));
    this.props.dispatch(ObtenerDatosUsuario());
  }
  CambiarCentroAtencion = (event, index, value) => {
    this.props.dispatch(CambiarCentroAtencion(value));
    this.props.dispatch(ObtenerTiposPrestacion(value));
    this.props.dispatch(ObtenerTiposArancel(value));
  }

  CambiarTipoArancel = (event, index, value) => {
    this.props.dispatch(CambiarTipoArancel(value));
  }

  CambiarTipoPrestacion = (event, index, value) => {
    this.props.dispatch(CambiarTipoPrestacion(value));
  }

  CambiarCodFonasa = (event) => {
    const re = /^[0-9;]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(CambiarCodFonasa(event.target.value));
    }
  }

  CambiarCodPrestacion = (event) => {
    this.props.dispatch(CambiarCodPrestacion(event.target.value));
  }

  InfoExpand = (expanded) => {
    this.props.dispatch(InfoExpand(expanded));
  }

  BuscarArancelesDetalle = () => {
    this.props.dispatch(Loading(true));
    this.props.dispatch(BuscarArancelesDetalle());
  }

  CloseModalConsultarPeriodoReajuste = () => {
    this.props.periodoReajuste.FechaVigencia = null;
    this.props.dispatch(ModalConsultarPeriodoReajuste(false));
  }

  ContinuarSolicitudModalSolicitudReajuste = () => {
    let arancelDescargado = 0;
    let paqueteDescargado = 0;
    let arancelCompleto = parseInt(sessionStorage.getItem('arancelCompleto')) || null;
    let paquetesCompleto = parseInt(sessionStorage.getItem('paquetesCompleto')) || null;

    if (this.props.periodoReajuste.ValidoArancel === 1) {
      if (arancelCompleto === 1) {
        arancelDescargado = 1;
      }
    }

    if (this.props.periodoReajustePQ.ValidoPaquetes === 1) {
      if (paquetesCompleto === 1) {
        paqueteDescargado = 1;
      }
    }

    if (this.props.periodoReajuste.ValidoArancel === 1 && this.props.periodoReajustePQ.ValidoPaquetes === 1) {
      if (arancelDescargado === 1 && paqueteDescargado === 1) {
        this.props.dispatch(ModalConsultarPeriodoReajuste(false));
        this.props.dispatch(ModalSolicitudReajustePaso(1));
      } else {
        this.setState({ infoAlert: true });
      }
    } else if (this.props.periodoReajuste.ValidoArancel === 1 && (this.props.periodoReajustePQ.ValidoPaquetes === 0 || this.props.periodoReajustePQ.ValidoPaquetes === null)) {
      if (arancelDescargado === 1) {
        this.props.dispatch(ModalConsultarPeriodoReajuste(false));
        this.props.dispatch(ModalSolicitudReajustePaso(1));
      } else {
        this.setState({ infoAlert: true });
      }
    } else if (this.props.periodoReajustePQ.ValidoPaquetes === 1 && (this.props.periodoReajuste.ValidoArancel === 0 || this.props.periodoReajuste.ValidoArancel === null)) {
      if (paqueteDescargado === 1) {
        this.props.dispatch(ModalConsultarPeriodoReajuste(false));
        this.props.dispatch(ModalSolicitudReajustePaso(1));
      } else {
        this.setState({ infoAlert: true });
      }
    } else {
      this.setState({ infoAlert: true });
    }
  }

  ContinuarSolicitudModalSolicitudReajuste2 = () => {
    //this.props.dispatch(ModalConsultarPeriodoReajuste(false));
    this.setState({ infoAlert: false })
    this.props.dispatch(ModalSolicitudReajustePaso(1));
  }

  CambiarFechaVigenciaConsultaPeriodo = (event, date) => {
    this.props.periodoReajuste.Validado = null;
    /* const dateMin = new Date(Date.now());
    dateMin.setDate(dateMin.getDate() + this.props.ENV.REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA);
    dateMin.setHours(0, 0, 0, 0);
    let dateMod = date;
    if (dateMin > date) {
      dateMod = dateMin;
      this.props.dispatch(CambiarFechaVigenciaConsultaPeriodo(dateMod, `La fecha no puede ser menor a ${dateMin.toLocaleDateString()}`));
    } else { */
    this.props.dispatch(CambiarFechaVigenciaConsultaPeriodo(date/* dateMod, null */));
    //}
    this.props.dispatch(ValidarPeriodoReajuste(date));
  }

  callbackFunction = (childData) => {
    //console.log("CHILD DATA DESDE FILTRO BUSQUEDA: ", childData);
    this.setState({ pagina: childData });
  }

  DownloadArancelCompleto = () => {
    this.props.dispatch(LoadingFileArancelCompleto(true));
    this.props.dispatch(DownloadArancelCompleto());
  }

  DownloadPaqueteCompleto = () => {
    //this.props.dispatch(LoadingFileArancelCompleto(true));
    this.props.dispatch(GetSolicitudesExcel());
  }

  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let today = new Date();
    today.setDate(today.getDate() + fechaVigenciaPrestador);
    const minDate = today;

    const menuListTipoArancel = [];
    if (this.props.tiposArancel) {
      this.props.tiposArancel.forEach((element) => {
        menuListTipoArancel.push(<MenuItem key={element.Rut} value={element.Rut} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListCentroAtencion = [];
    if (this.props.centrosAtencion) {
      this.props.centrosAtencion.forEach((element) => {
        menuListCentroAtencion.push(<MenuItem key={element.Secuencia} value={element.Secuencia} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListTipoPrestaciones = [];
    if (this.props.tiposPrestaciones) {
      this.props.tiposPrestaciones.forEach((element) => {
        if (element.Id > 0) {
          menuListTipoPrestaciones.push(<MenuItem key={element.Id} value={element.Id} primaryText={`${element.TipoAtencion}: ${element.Descripcion}`} style={styles.customWidthItem} />);
        } else {
          menuListTipoPrestaciones.push(<MenuItem key={element.Id} value={element.Id} primaryText={element.Descripcion} style={styles.customWidthItem} />);
        }
      });
    }

    const actionsConsultarPeriodoReajuste = [
      <div style={{ marginTop: 15 }}>
        {
          (this.props.periodoReajuste.FechaVigencia && this.props.periodoReajuste.Validado == null) ?
            <CircularProgress style={{ paddingRight: 60 }} /> : null
        }
        <RaisedButton
          onClick={this.CloseModalConsultarPeriodoReajuste}
          label="Cerrar"
          backgroundColor="#fff"
          overlayStyle={{ borderRadius: 5 }}
          labelStyle={{
            fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5,
          }}
          style={{ width: "145px", borderRadius: 5 }}
          buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
        />
        {(this.props.periodoReajuste.Validado || false) ?
          <RaisedButton
            label="Continuar"
            onClick={this.ContinuarSolicitudModalSolicitudReajuste}
            secondary
            labelStyle={{ fontSize: "11px" }}
            overlayStyle={{ borderRadius: 5 }}
            rippleStyle={{ borderRadius: 5 }}
            style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
            buttonStyle={{ borderRadius: 5 }}
          /> :
          <RaisedButton
            label="Continuar"
            // onClick={this.ContinuarSolicitudModalSolicitudReajuste}
            secondary
            disabled
            labelStyle={{ fontSize: "11px" }}
            overlayStyle={{ borderRadius: 5 }}
            rippleStyle={{ borderRadius: 5 }}
            style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
            buttonStyle={{ borderRadius: 5 }}
          />
        }
      </div>,
    ];


    let fechaInicio = "--/--/----";
    if (this.props.periodoReajuste.FechaInicio) {
      fechaInicio = moment(this.props.periodoReajuste.FechaInicio).format("DD/MM/YYYY");
      //fechaInicio = this.props.periodoReajuste.FechaInicio;
    }
    let fechaTermino = "--/--/----";
    if (this.props.periodoReajuste.FechaTermino) {
      //fechaTermino = this.props.periodoReajuste.FechaTermino;
      fechaTermino = moment(this.props.periodoReajuste.FechaTermino).format("DD/MM/YYYY");
    }

    let fechaInicioPQ = "--/--/----";
    if (this.props.periodoReajustePQ.FechaInicio) {
      fechaInicioPQ = moment(this.props.periodoReajustePQ.FechaInicio).format("DD/MM/YYYY");
      //fechaInicio = this.props.periodoReajuste.FechaInicio;
    }
    let fechaTerminoPQ = "--/--/----";
    if (this.props.periodoReajustePQ.FechaTermino) {
      //fechaTermino = this.props.periodoReajuste.FechaTermino;
      fechaTerminoPQ = moment(this.props.periodoReajustePQ.FechaTermino).format("DD/MM/YYYY");
    }

    return (
      <div>

        {this.props.token ?
          <div>
            {(this.props.periodoReajuste.Validado === true || this.props.periodoReajustePQ.Validado === true) ?
              <div className="col-12" style={{ fontSize: "13px", marginTop: "22px" }}>
                <div className="contenido" style={{ margin: 0, padding: 0, width: 925 }}>
                  <div style={styles.h1}>Solicitar Reajuste por IPC
                  </div>
                  <div style={{ marginBottom: "5px" }}></div>
                  <div style={styles.h3}>Rut Institución: {this.props.rutInstitucion}
                  </div>
                  <div style={{ marginBottom: "22px" }}></div>
                  <p>Estimado usuario: </p>
                  <p>
                    Esta funcionalidad se encuentra habilitada, según su calendario de reajustabilidad.
                    Este reajuste se realizará sobre todos los grupos de prestación seleccionados.
                    En caso de que desee realizar modificaciones, deberá solicitarlas y
                    luego de tener una resolución de la Isapre, teniendo los valores cargados y actualizados,
                    usted deberá solicitar el reajuste. Lo mismo se aplica para paquetes quirúrgicos.
                  </p>
                  {(this.props.periodoReajuste.Validado === true) ?
                    <p>
                      El reajuste habilitado por Convenios Médicos para los Aranceles es de un {this.props.periodoReajuste.ValorReajuste}% y podrá ser solicitdado desde {fechaInicio} hasta el {fechaTermino}.
                    </p>
                    : null
                  }
                  {(this.props.periodoReajuste.Observacion != null) ?
                    <p>
                      Observación Convenios Reajuste Arancel: {this.props.periodoReajuste.Observacion}.
                    </p> : null
                  }
                  {(this.props.periodoReajustePQ.Validado === true) ?
                    <p>
                      El reajuste habilitado por Convenios Médicos para los Paquetes Quirúrgicos es de un {this.props.periodoReajustePQ.ValorReajuste}% y podrá ser solicitdado desde {fechaInicioPQ} hasta el {fechaTerminoPQ}.
                    </p>
                    : null
                  }
                  {(this.props.periodoReajustePQ.Observacion != null) ?
                    <p>
                      Observación Convenios Reajuste de Paquetes: {this.props.periodoReajustePQ.Observacion}.
                    </p> : null
                  }
                  <p>
                    Los convenios autorizados son los siguientes:
                  </p>
                  {(this.props.periodoReajuste.ValidoArancel === 1) ?
                    <div style={{ fontSize: "18px", marginBottom: "22px" }}>- Arancel
                      {(this.props.loadingFileArancelCompleto === false) ?
                        <RaisedButton
                          label="Descarga Arancel Completo"
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "250px", borderRadius: 5, marginLeft: 45 }}
                          buttonStyle={{ borderRadius: 5 }}
                          onClick={this.DownloadArancelCompleto}
                        />
                        :
                        <RaisedButton
                          label="Cargando ..."
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "250px", borderRadius: 5, marginLeft: 45 }}
                          buttonStyle={{ borderRadius: 5 }}
                        />
                      }
                    </div>
                    : null}
                  {(this.props.periodoReajustePQ.ValidoPaquetes === 1) ?
                    <div style={{ fontSize: "18px" }}>- Paquetes
                      <RaisedButton
                        label="Descarga Paquetes Completo"
                        secondary
                        labelStyle={{ fontSize: "11px" }}
                        overlayStyle={{ borderRadius: 5 }}
                        rippleStyle={{ borderRadius: 5 }}
                        style={{ width: "250px", borderRadius: 5, marginLeft: 30 }}
                        buttonStyle={{ borderRadius: 5 }}
                        onClick={this.DownloadPaqueteCompleto}
                      />
                    </div> : null}
                  <div className="col-12" style={{ textAlign: "right" }}>
                    <RaisedButton
                      label="Continuar"
                      onClick={this.ContinuarSolicitudModalSolicitudReajuste}
                      secondary
                      labelStyle={{ fontSize: "11px" }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                      buttonStyle={{ borderRadius: 5 }}
                    />
                  </div>
                </div>
              </div>
              :
              <div className="col-12" style={{ fontSize: "13px", marginTop: "22px" }}>
                <p>Estimado usuario: </p>
                <p>
                  Esta funcionalidad se encuentra deshabilitada, según su calendario de
                  reajustabilidad.  Debe realizar la solicitud, sólo durante el periodo definido.
                </p>
                <p>
                  Este reajuste se realizará sobre todo el grupo de prestación o arancel completo.
                  En caso de que desee realizar modificaciones, deberá solicitar las modificaciones y
                  luego de tener una resolución de la Isapre, teniendo los valores cargados y actualizados,
                  usted deberá solicitar el reajuste. Lo mismo para paquetes quirúrgicos.
                </p>
                <p>
                  <strong>
                    Importante
                    <br></br>
                    Antes de solicitar un reajuste verifique que los valores están actualizados.
                    De lo contrario, deberá corregir los valores mediante la solicitud pertiente.
                  </strong>
                </p>
              </div>
            }
            <Drawer
              width="100%"
              openSecondary
              open={this.props.modalSolicitudReajuste}
              docked={false}
            >
              {this.props.modalSolicitudReajuste ?
                <SolicitudReajuste />
                : null}
            </Drawer>

            <Drawer
              width="100%"
              openSecondary
              open={this.props.modalSolicitudReajusteConfirmacion}
              docked={false}
            >
              {this.props.modalSolicitudReajusteConfirmacion ?
                <SolicitudReajusteConfirmacion />
                : null}
            </Drawer>

            <Drawer
              width="100%"
              openSecondary
              open={this.props.modalSolicitudReajusteRespuesta}
              docked={false}
            >
              {this.props.modalSolicitudReajusteRespuesta ?
                <SolicitudReajusteRespuesta />
                : null}
            </Drawer>

            <Dialog
              key="dialogConsultarPeriodoReajuste"
              id="dialogConsultarPeriodoReajuste"
              actions={actionsConsultarPeriodoReajuste}
              modal
              open={this.props.modalColsultarPeriodoReajuste}
              style={{ fontSize: "13px" }}
            >
              <div className="row">
                {(this.props.periodoReajuste.Validado == 1 || this.props.periodoReajuste.Validado == null) || !this.props.periodoReajuste.FechaVigencia ?
                  null
                  :
                  <div className="col-12" style={{ fontSize: "13px", marginTop: "22px" }}>
                    <p>Estimado usuario: </p>
                    <p>
                      Esta funcionalidad se encuentra deshabilitada, según su calendario de
                      reajustabilidad.  Debe realizar la solicitud, sólo durante el periodo definido.
                    </p>
                  </div>
                }

              </div>
            </Dialog>

            <Dialog
              key="dialogEliminarCaract"
              id="dialogEliminarCaract"
              actions={[
                <FlatButton
                  label="VOLVER"
                  primary
                  onClick={() => this.setState({ infoAlert: false })}
                />
                ,
                <FlatButton
                  label="CONTINUAR"
                  primary
                  onClick={() => this.ContinuarSolicitudModalSolicitudReajuste2()}
                />
              ]}
              modal
              open={this.state.infoAlert}
              style={{ width: "700px", fontSize: "13px" }}
            >
              <p>
                Usted no ha descargado todos los archivos disponibles. Le recordamos que el reajuste se aplicará
                sobre la información cargada en nuestros sistemas y que está disponible en estos archivos.</p>
              <p>
                Si desea continuar de todos modos, por favor seleccione CONTINUAR. De lo contrario, presione VOLVER
                y descargue todos los archivos.
              </p>
            </Dialog>

          </div>
          :
          <div>NO TENGO TOKEN</div>}
      </div>
    );
  }
}

FiltroBusquedaRA.propTypes = {
  loading: PropTypes.bool.isRequired,
  loadingFileArancelCompleto: PropTypes.bool.isRequired,
  infoExpanded: PropTypes.bool.isRequired,
  busquedaarancelesDetalle: PropTypes.bool.isRequired,
  modalSolicitudReajuste: PropTypes.bool.isRequired,
  modalSolicitudReajusteConfirmacion: PropTypes.bool.isRequired,
  modalSolicitudReajusteRespuesta: PropTypes.bool.isRequired,
  modalColsultarPeriodoReajuste: PropTypes.bool.isRequired,
  rutInstitucion: PropTypes.number.isRequired,
  tiposArancel: PropTypes.array.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  tiposPrestaciones: PropTypes.array.isRequired,
  filtros: PropTypes.any.isRequired,
  periodoReajuste: PropTypes.any.isRequired,
  periodoReajustePQ: PropTypes.any.isRequired,
  solicitudEnCurso: PropTypes.bool.isRequired,
  ENV: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.filtroBusquedaRA.loading,
  loadingFileArancelCompleto: state.filtroBusquedaRA.loadingFileArancelCompleto,
  infoExpanded: state.filtroBusquedaRA.infoExpanded,
  busquedaarancelesDetalle: state.filtroBusquedaRA.busquedaarancelesDetalle,
  modalSolicitudReajuste: state.solicitudReajuste.modalSolicitudReajuste,
  modalSolicitudReajusteConfirmacion: state.solicitudReajuste.modalSolicitudReajusteConfirmacion,
  modalSolicitudReajusteRespuesta: state.solicitudReajuste.modalSolicitudReajusteRespuesta,
  modalColsultarPeriodoReajuste: state.solicitudReajuste.modalColsultarPeriodoReajuste,
  rutInstitucion: state.global.rutInstitucion,
  tiposArancel: state.global.filtros_CAT.tiposArancel,
  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  tiposPrestaciones: state.global.filtros_CAT.tiposPrestaciones,
  filtros: {
    tipoArancel: state.global.filtros_CAT.tipoArancel,
    centroAtencion: state.global.filtros_CAT.centroAtencion,
    tipoPrestacion: state.global.filtros_CAT.tipoPrestacion,
    codFonasa: state.global.filtros_CAT.codFonasa || "",
    codPrestacion: state.global.filtros_CAT.codPrestacion || "",
  },
  periodoReajuste: state.filtroBusquedaRA.periodoReajuste,
  periodoReajustePQ: state.filtroBusquedaRA.periodoReajustePQ,
  solicitudEnCurso: state.filtroBusquedaRA.solicitudEnCurso,
  ENV: state.global.ENV,
  token: state.global.token,
  datosUsuario: state.global.datosUsuario,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(FiltroBusquedaRA);




// WEBPACK FOOTER //
// ./src/components/ReajustarArancel/FiltroBusqueda/view.jsx